import React, { useState } from 'react'
import {
  Form,
  Button,
  Container,
  ButtonGroup,
  ToggleButton
} from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

const SearchBoxPos = () => {
  const [keyword, setKeyword] = useState('')
  const [radioValue, setRadioValue] = useState('1')

  const navigate = useNavigate()

  const submitHandler = (e) => {
    e.preventDefault()
    if (keyword.trim()) {
      let word = keyword
      let radio = radioValue
      let wordradio = word + radio

      navigate(`/searchpos/${wordradio}/*`)
    } else {
      setKeyword('')
      setRadioValue('1')
      navigate('/pos')
    }
  }

  const radios = [
    { name: 'UPC', value: '1' },
    { name: 'Mfg', value: '2' },
    { name: 'Name', value: '3' }
  ]

  return (
    <Container className='search-shell pos-search-shell'>
      <Form className='pos-search-form' onSubmit={submitHandler}>
        <Form.Control
          type='text'
          name='q'
          onChange={(e) => setKeyword(e.target.value)}
          placeholder='Search by UPC, manufacturer, or item name'
          aria-label='Search products'
          className='search-input pos-search-input'
        />
        <Button
          type='submit'
          variant='primary'
          className='search-action-btn pos-search-submit'
        >
          Search products
        </Button>
        <div className='pos-search-mode'>
          <span className='pos-search-mode-label'>Search by</span>
          <ButtonGroup className='search-toggle-group' aria-label='Search by'>
            {radios.map((radio, idx) => (
              <ToggleButton
                key={idx}
                id={`radio-${idx}`}
                type='radio'
                variant='outline-secondary'
                name='radio'
                value={radio.value}
                checked={radioValue === radio.value}
                onChange={(e) => setRadioValue(e.currentTarget.value)}
              >
                {radio.name}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </div>
      </Form>
    </Container>
  )
}

export default SearchBoxPos
